// extracted by mini-css-extract-plugin
module.exports = {"categories":"index_categories_3n1vi","category":"index_category_1Akl1","title":"index_title_Z0ys2","current":"index_current_10hJ4"};